import { inject, Injectable } from '@angular/core';
import { CB_CORE_ENV } from '../../../environment/cb-core-env.token';

@Injectable()
export class AppVersionService {
  private env = inject(CB_CORE_ENV);

  getAppVersion(): string {
    return `v${this.env.appVersion ?? ''}`;
  }
}
